import { IsBoolean, Length } from 'class-validator';

export class PublicProfileVerifyManagementModel {
  @Length(32, 36)
  public versionId: string;

  @IsBoolean()
  public accepted: boolean;
}
